import React from "react";

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconChemicallyInduced = ({
  width = 24,
  height = 24,
  color = "#515C6C",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 2.375C16.3452 2.375 16.625 2.65482 16.625 3C16.625 3.34518 16.3452 3.625 16 3.625H15.625V7.36816C18.5445 8.5249 20.625 11.2639 20.625 14.4912C20.625 14.6239 20.6202 14.7557 20.6133 14.8867C20.62 14.9235 20.625 14.9612 20.625 15C20.625 15.0679 20.6108 15.1322 20.5908 15.1934C20.3644 17.5772 18.9981 19.6387 17.0322 20.8955C16.8982 20.9811 16.7444 21.0253 16.5898 21.0254H8.41016C8.25562 21.0253 8.10181 20.9811 7.96777 20.8955C6.00191 19.6387 4.63559 17.5772 4.40918 15.1934C4.38916 15.1322 4.375 15.0679 4.375 15C4.375 14.9612 4.37996 14.9235 4.38672 14.8867C4.37975 14.7557 4.37501 14.6239 4.375 14.4912C4.375 11.2639 6.45546 8.5249 9.375 7.36816V3.625H9C8.65482 3.625 8.375 3.34518 8.375 3C8.375 2.65482 8.65482 2.375 9 2.375H16ZM10.625 7.80371C10.6249 8.07244 10.4531 8.31128 10.1982 8.39648C7.5514 9.28098 5.67939 11.6324 5.62793 14.375H7.5C7.84518 14.375 8.125 14.6548 8.125 15C8.125 15.3452 7.84518 15.625 7.5 15.625H5.73242C6.05319 17.3289 7.08397 18.8075 8.54199 19.7754H16.458C17.916 18.8075 18.9468 17.3289 19.2676 15.625H17.5C17.1548 15.625 16.875 15.3452 16.875 15C16.875 14.6548 17.1548 14.375 17.5 14.375H19.3721C19.3206 11.6324 17.4486 9.28098 14.8018 8.39648C14.5469 8.31128 14.3751 8.07244 14.375 7.80371V3.625H10.625V7.80371ZM11.2031 10.2686C11.7783 9.24368 13.2216 9.24379 13.7969 10.2686L16.8994 15.7998C17.4675 16.8141 16.7613 18.0992 15.6025 18.0996H9.39746C8.23856 18.0992 7.53221 16.8152 8.10059 15.8008L11.2031 10.2686ZM12.7549 10.877C12.6404 10.6738 12.3595 10.6737 12.2451 10.877L9.14258 16.4092C9.0232 16.6228 9.17751 16.8747 9.39746 16.875H15.6025C15.8224 16.8746 15.9765 16.6227 15.8574 16.4092L12.7549 10.877ZM12.4385 15.3447C12.7769 15.3451 13.0515 15.6195 13.0518 15.958C13.0517 16.2966 12.777 16.5719 12.4385 16.5723C12.0996 16.5723 11.8243 16.2969 11.8242 15.958C11.8245 15.6193 12.0997 15.3447 12.4385 15.3447ZM12.4385 12.4561C12.7771 12.4564 13.0518 12.6981 13.0518 12.9961V14.4365C13.0514 14.7343 12.7769 14.9762 12.4385 14.9766C12.0998 14.9766 11.8245 14.7345 11.8242 14.4365V12.9961C11.8242 12.6979 12.0996 12.4561 12.4385 12.4561Z"
        fill={color}
        className="therapeutic-area-icon-fill"
      />
    </svg>
  );
};

IconChemicallyInduced.displayName = "Chemically Induced";

export default IconChemicallyInduced;
